"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const he_1 = __importDefault(require("he"));
const server_1 = __importDefault(require("react-dom/server"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const emojiFunctions_1 = require("../../utils/emojiFunctions");
const urlFunctions_1 = require("../../utils/urlFunctions");
const Emoji_1 = __importDefault(require("./Emoji"));
exports.default = react_1.default.memo(TextContent);
const useStyles = makeStyles_1.default((theme) => ({
    sentByMe: {
        "& a": {
            color: "inherit"
        }
    }
}));
function TextContent(props) {
    const classes = useStyles();
    function markupText(text, plainText) {
        // First HTML encode the text
        text = he_1.default.encode(text);
        // Wrap contiguous emoji chars in an "emoji span"
        let markup = "";
        let emojis = "";
        for (const c of text) {
            const isEmoji = emojiFunctions_1.containsEmoji(c);
            // If the char is an emoji or a zero-width joiner &zwj;
            // then accumulate the chars in a string to be wrapped in an "emoji span"
            if (isEmoji || c == '\u200D') {
                emojis += c;
            }
            else {
                if (emojis.length) {
                    markup += server_1.default.renderToStaticMarkup(react_1.default.createElement(Emoji_1.default, { text: emojis }));
                    emojis = "";
                }
                markup += c;
            }
        }
        if (emojis.length) {
            markup += server_1.default.renderToStaticMarkup(react_1.default.createElement(Emoji_1.default, { text: emojis }));
        }
        if (!plainText) {
            // Try to wrap links in <a> tags
            markup = urlFunctions_1.wrapURLsInAnchorTags(markup, true);
            // Replace newlines with <br> tags
            markup = markup.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }
        return markup;
    }
    const markup = markupText(props.text, props.plainText);
    const className = props.sentByMe ? classes.sentByMe : undefined;
    return (react_1.default.createElement(Typography_1.default, { className: className, variant: props.variant, dangerouslySetInnerHTML: { __html: markup } }));
}
